<script>
export default {
  name: 'NotifyHistory',
  props: {
    InfoId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      taskList: [],
      loading: false
    }
  },
  methods: {
    async getNotifyTaskList() {
      this.loading = true
      const { list } = await this.$api.dingTalkNotifyHistory(this.InfoId)
      this.$nextTick(() => {
        this.taskList = list || []
        this.loading = false
      })
    }
  }
}

</script>

<template>
  <div>
    <el-link icon='el-icon-refresh' @click='getNotifyTaskList'>通知历史记录：</el-link>
    <div v-loading='loading'  element-loading-text='加载中……'
         element-loading-spinner='el-icon-loading'>
      <el-table :data='taskList' highlight-current-row>
        <!--      <el-table-column prop="id" label="任务Id"></el-table-column>-->
        <el-table-column prop='sender_name' label='发送人' width='80'></el-table-column>
        <el-table-column prop='send_status_alias' label='发送状态' width='70'></el-table-column>
        <el-table-column prop='send_time' label='发送时间' width='140' show-overflow-tooltip></el-table-column>
        <el-table-column prop='msg_param.title' label='标题' width='150' show-overflow-tooltip></el-table-column>
        <el-table-column prop='msg_param.text' label='内容' show-overflow-tooltip></el-table-column>
      </el-table>
    </div>

  </div>
</template>

<style scoped>

</style>
